


















































import { Form, FormItem, Input, Button } from 'element-ui'
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'

import CreditCardInput from '@/components/CreditCardInput.vue'

import ErrorEntities from '@/models/error-entities'
import NewCreditCardForm from '@/models/new-credit-card-form'

@Component({
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
    CreditCardInput,
  },
})
export default class AddCreditCardForm extends Vue {
  @Prop() stripeSdkLoaded!: boolean
  @Prop() serverErrors!: ErrorEntities

  @Ref() readonly creditCardForm!: Form
  @Ref() readonly creditCardRef!: CreditCardInput

  serverBakedErrors = {}
  submitDisabled = false

  form: NewCreditCardForm = {
    aliasName: '',
    cardholderName: '',
    stripePaymentMethod: '',
    stripePublicKey: '',
  }

  rules = {
    aliasName: [{ required: true, message: 'Payment Name is required' }],
    cardholderName: [
      { required: true, message: 'Card Holders Name is required' },
    ],
    creditCard: [
      {
        validator: async (
          rule: any,
          value: undefined,
          callback: (errors?: string) => void,
        ) => {
          const response = await this.creditCardRef.getStripePaymentMethod(
            this.form.cardholderName,
          )
          if (response.error) {
            callback(response.error.message)
          } else {
            this.form.stripePaymentMethod =
              (response.paymentMethod && response.paymentMethod.id) || ''
          }
        },
      },
    ],
  }

  private elementsErrors: string[] = []

  get creditCardErrors() {
    return [...this.elementsErrors, ...(this.serverErrors.stripe || [])]
  }

  handleAddCard() {
    this.submitDisabled = true
    try {
      this.$emit('on-card-create', this.form)
    } catch {
      this.submitDisabled = false
    }
  }

  resetForm() {
    this.creditCardForm.resetFields()
    this.creditCardRef.clearFields()
    this.submitDisabled = false
  }

  onCardError(errors: string[]) {
    this.elementsErrors = errors
  }
}
